/* eslint-disable no-param-reassign */
import _ from 'lodash';

export default function disableAllComponentMethodsOnUnmount(componentInstance) {
  _.functionsIn(componentInstance).forEach((fnName) => {
    componentInstance[fnName] = _.noop;
  });
}
